import ImageCard, {IImageCardProps} from './ImageCard';

export type {IImageCardProps};
export default ImageCard;
